import { Paper, Typography } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import { animations } from "helpers/animations";
import React, { useState } from "react";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";

export const CustomBox = (props) => {
  const { children, style, title, icon, count, bg } = props;
  const [isHovered, setIsHovered] = useState(false);
  const { isDark } = useThemeMode();

  const titleStyle = {
    minWidth: "100%",
    padding: 4,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    color: isDark ? darkPalette.accent : "#0054A8",
    marginBottom: 12,
    position: "sticky",
    left: 0,
    top: 0,
    backgroundColor: isDark ? darkPalette.cardBg : "white",
    zIndex: 4,
    borderBottom: `2px solid ${isDark ? darkPalette.accentBorder : blue[500]}`,
  };

  const componentStyle = {
    boxShadow: isDark
      ? "0 4px 4px 0 rgba(0,0,0,.5)"
      : "0 4px 4px 0 rgba(0,0,0,.25)",
    position: "relative",
    padding: 8,
    paddingTop: 0,
    overflow: "hidden",
    marginBottom: 8,
    backgroundColor: isDark ? darkPalette.cardBg : undefined,
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <Paper
      className={animations.fadeIn}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        ...componentStyle,
        ...style,
        animationDelay: ".5s",
      }}
    >
      {title ? (
        <Typography variant="subtitle1" component="h2" style={titleStyle}>
          {title}
          <span
            style={{
              color: blue[800],
              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            {icon}
            {count && (
              <small
                style={{
                  width: 25,
                  height: 25,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  borderRadius: 50,
                  backgroundColor: blue[400],
                }}
              >
                {count}
              </small>
            )}
          </span>
        </Typography>
      ) : null}

      {children}
      {isHovered ? (
        <div
          className={animations.fadeIn}
          style={{
            position: "absolute",
            left: -30,
            bottom: -50,
            zIndex: -1,
            opacity: 0.1,
            color: blue[100],
          }}
        >
          {bg}
        </div>
      ) : null}
    </Paper>
  );
};
